import React, { useEffect, useMemo } from 'react';
import { Route } from 'react-router-dom';
import { authenticationService } from './../services/authentication.service';
//import CasClient, { constant } from "react-cas-client";
import { createBrowserHistory } from 'history';

//import fetch from 'node-fetch';

import { loginRequest } from "../services/authConfig";
import { callMsGraph } from "../services/graph";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus, InteractionRequiredAuthError } from "@azure/msal-browser";

const APP_ID = process.env.REACT_APP_ID;
const API_URL = process.env.REACT_APP_API_URL;
const AUTH_URL = process.env.REACT_APP_AUTH_URL;
const CAS_SERVER = process.env.REACT_APP_CAS_SERVER;

const history = createBrowserHistory();

export const PrivateRoute = ({ component: Component, roles, ...rest }) => {

    const { instance, accounts, inProgress } = useMsal();

    const isAuthenticated = accounts.length > 0;
    const account = useMemo(() => (isAuthenticated ? accounts[0] : null), [isAuthenticated, accounts]);

    // 1) Si no está autenticado, inicia login por redirect (fuera de render)
    useEffect(() => {
        if (!isAuthenticated && inProgress === InteractionStatus.None) {
            instance.loginRedirect(loginRequest).catch(console.error);
        }
    }, [isAuthenticated, inProgress, instance]);

    // 2) Si sí está autenticado, pide token y haz tus llamadas
    useEffect(() => {
        let cancel = false;

        const run = async () => {
            if (!account || inProgress !== InteractionStatus.None) return;

            try {
                const response = await instance.acquireTokenSilent({ ...loginRequest, account });
                const graph = await callMsGraph(response.accessToken); // { mail, givenName, ... }
                if (cancel) return;

                const res = await fetch(`${API_URL}Login/GetDatosLogin/${encodeURIComponent(graph.mail)}`);
                const data = await res.json();
                if (cancel) return;

                //console.log("azureGetDatosUser:", graph);
                //console.log("responseJson:", data);


                authenticationService.login(data);
                // TODO: guarda en tu estado global/contexto si lo necesitas
                // authenticationService.login({ ...data.user, token: data.token });
            } catch (err) {
                if (err instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect({ ...loginRequest, account });
                } else {
                    //console.error(err);
                }
            }
        };

        run();
        return () => { cancel = true; };
    }, [account, inProgress, instance]);

     // 3) Render del Route (sin async)
    return (
        <Route {...rest}
            render={(props) => (isAuthenticated ? <Component {...props} /> : null)}
        />
    );
};